import React, { useState, useEffect } from 'react'
import { Box, Typography, Button, CircularProgress } from '@mui/material'
import { Helmet } from 'react-helmet-async'
import { Navbar } from '../component/shared/Navbar'
import { SalesFilter } from '../component/point/SalesFilter'
import { PageContainer } from '../component/styled/PageContainer'
import { NexenTripTable } from '../component/point/NexenTripTable'
import { useAuth } from '../api/context/UserAuthContext'
import ErrorMessage from '../component/shared/component/ErrorMessage'
import { SearchFilter } from '../component/point/SearchFilter'
import { superiorArray, superiorSalesList } from '../constant/nex-point-superior'
import DownloadIcon from '@mui/icons-material/Download'
import { useExportNexTripPoint } from '../api/point'
import { useSnackbar } from 'notistack'
import {
  NEXEN_TRIP_POINT_START_DATE,
  NEXEN_TRIP_POINT_END_DATE,
} from '../constant/point-system-date'

export const NexenTripPointPanelScreen = () => {
  const { user } = useAuth()
  const [salesId, setSalesId] = useState()
  const [searchFilter, setSearchFilter] = useState('')

  const isSalesman = !user?.isPointSystemAdmin && !superiorArray.includes(user?.salesId)
  const superiorList = superiorArray.includes(user?.salesId) ? superiorSalesList[user?.salesId] : []

  const { enqueueSnackbar } = useSnackbar()
  const exportApi = useExportNexTripPoint()

  const handleExportNex = async () => {
    const defaultQueries = {
      startDate: NEXEN_TRIP_POINT_START_DATE,
      endDate: NEXEN_TRIP_POINT_END_DATE,
    }
    const res = await exportApi.mutateAsync(defaultQueries).catch((e) => {
      enqueueSnackbar('Failed to export data', {
        variant: 'error',
      })
    })
    const url = URL.createObjectURL(res.data)

    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `nexen-trip.xlsx`)
    document.body.appendChild(link)
    link.click()

    if (res?.status === 200) {
      enqueueSnackbar(`Exported`, {
        variant: 'success',
      })
    }

    return res
  }

  useEffect(() => {
    if (user?.salesId && isSalesman) {
      setSalesId(user?.salesId)
    }
  }, [user, isSalesman])

  return (
    <>
      <Helmet titleTemplate='%s | Point System' defaultTitle='Point System'>
        <title>Nexen Trip</title>
      </Helmet>
      <Navbar />

      <PageContainer>
        <Box
          display='flex'
          justifyContent='space-between'
          flexDirection='column'
          px={{ xs: 3, md: 8 }}
          pt={3}
        >
          <Typography variant='h1'>Nexen Trip Point</Typography>
          <Box
            display='flex'
            alignItems={{ sm: 'center' }}
            flexDirection={{ xs: 'column', sm: 'row' }}
          >
            <SearchFilter onChange={setSearchFilter} />
            {!isSalesman && (
              <SalesFilter
                salesId={salesId}
                setSalesId={setSalesId}
                htgCompany={['hwt', 'htp']}
                startDate={NEXEN_TRIP_POINT_START_DATE}
                endDate={NEXEN_TRIP_POINT_END_DATE}
                superiorList={superiorList}
              />
            )}
          </Box>
          <Box display='flex' justifyContent='flex-end'>
            <Button
              startIcon={<DownloadIcon />}
              endIcon={exportApi.isLoading && <CircularProgress size='1.5rem' />}
              onClick={handleExportNex}
              disabled={exportApi.isLoading}
            >
              Export Data
            </Button>
          </Box>
        </Box>
        <Box pt={3} pb={10} px={{ xs: 3, sm: 5, md: 10 }}>
          {!isSalesman || salesId ? (
            <NexenTripTable
              salesId={salesId}
              searchFilter={searchFilter}
              superiorList={superiorList}
            />
          ) : (
            <ErrorMessage error message={'Need admin permission or sales id'} />
          )}
        </Box>
      </PageContainer>
    </>
  )
}
